import Navbar from '../home/components/Navbar';
import Footer from '../home/components/Footer';
import ProductsHero from './components/ProductsHero';
import ProductCategories from './components/ProductCategories';
import ThreeTierLegend from './components/ThreeTierLegend';
import ContactCTA from './components/ContactCTA';

export default function Products() {
  return (
    <div className="min-h-screen bg-[#1A1A1A]">
      <Navbar />
      <ProductsHero />
      <ThreeTierLegend />
      <ProductCategories />
      <ContactCTA />
      <Footer />
    </div>
  );
}